import { Link } from 'react-router-dom';
import cn from '../../lib/cn';

const variants = {
  primary:
    'bg-brand-600 text-white shadow-soft hover:bg-brand-700 hover:shadow-lift hover:-translate-y-0.5 active:translate-y-0',
  secondary:
    'bg-ink-900 text-white shadow-soft hover:bg-ink-800 hover:-translate-y-0.5 active:translate-y-0',
  outline:
    'border border-ink-200 bg-white text-ink-800 hover:border-brand-400 hover:text-brand-700 hover:-translate-y-0.5 active:translate-y-0',
  ghost: 'text-ink-700 hover:bg-ink-100 hover:text-ink-900',
  light:
    'bg-white text-brand-800 shadow-soft hover:bg-brand-50 hover:-translate-y-0.5 active:translate-y-0',
  onDark:
    'border border-white/25 text-white hover:border-white/60 hover:bg-white/10 hover:-translate-y-0.5 active:translate-y-0',
  danger: 'bg-red-600 text-white hover:bg-red-700',
};

const sizes = {
  sm: 'px-4 py-2 text-xs',
  md: 'px-5 py-2.5 text-sm',
  lg: 'px-7 py-3.5 text-[0.95rem]',
};

/**
 * One button for the whole app. Renders as <Link>, <a> or <button>
 * depending on whether `to` or `href` is supplied.
 */
export default function Button({
  as,
  to,
  href,
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...rest
}) {
  const classes = cn('btn', variants[variant], sizes[size], className);

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} {...rest}>
        {children}
      </a>
    );
  }

  const Component = as || 'button';
  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  );
}
